module.exports = __webpack_public_path__ + "images/emoji/elephant.6de23e4bd4c092ef9ecd.png";